import { ServiceFetch } from '../service-fetch'

export default class ProductSupplierModel extends ServiceFetch {
    getProductSupplierBy = (data) => this.authFetch({
        url: 'product-supplier/getProductSupplierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getProductSupplierByCode = (data) => this.authFetch({
        url: 'product-supplier/getProductSupplierByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
}